import { defineStore } from 'pinia';
import { appModes, appModesKeys, categoriesSections } from '@/Constants/common';
import { useStoreData } from '@/Store/storeData';
import { roomSetupUiPositions } from '@/Constants/roomSetupUiPositions';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { roomConfigurePositions } from '@/Constants/roomConfigurePositions';

export const useUIOnlyStore = defineStore('UIOnlyStore', {
    state: () => ({
        loadProgress: 0,
        mode: 0, // 0 - empty,  1 - room; 2 - wardrobe
        positions: {
            ...roomSetupUiPositions,
        },
        configurePositions: JSON.parse(JSON.stringify(roomConfigurePositions)),
        is3dLoaded: false,
        isRuler: false,
        isDecoration: false,
        isTooltip: false,
        isElementInfoActive:true,
        selectedSceneObject: {
            uuid: null,
            label: null,
            text: null,
            hasRod: false,
        },
        loader: false,
        deleteFlag: false,
        // positionWallInput1: [ ...roomSetupUiPositions.positionWallInput1 ], // [x, y]
        // positionWallInput2: [ ...roomSetupUiPositions.positionWallInput2 ], // [x, y]
        // positionWallInput3: [ ...roomSetupUiPositions.positionWallInput3 ], // [x, y]
        // positionRoomType: [ ...roomSetupUiPositions.positionRoomType ], // [x, y]
        // positionRoomConfirm: [ ...roomSetupUiPositions.positionRoomConfirm ], // [x, y]
    }),
    getters: {
        getSelectedSceneObject: (state) => {
            return state.selectedSceneObject;
        },
        getElementInfoActive:(state)=>{
            return state.isElementInfoActive;
        },
        getSelectedDoor: (state) => {
            if (state.selectedSceneObject.label === 'Дверь') {
                return useConfigurationStore().getDoors.filter((item : string) =>
                    item.uuid === state.selectedSceneObject.uuid)[0];
            }
            if (state.selectedSceneObject.label === 'Окно') {
                return useConfigurationStore().getWindows.filter((item : string) =>
                    item.uuid === state.selectedSceneObject.uuid)[0];
            }
            return {};
        },
        getSelectedBox: (state) => {
            if (state.selectedSceneObject.label === 'Куб') {
                return useConfigurationStore().getBoxes.filter((item : string) =>
                    item.uuid === state.selectedSceneObject.uuid)[0];
            }
            return {};
        },
        getIsSidebarMenu: () => {
            return (
                useStoreData().getActiveCategory !== null
                // &&
                // useStoreData().getActiveCategoriesSection === categoriesSections.catalog
            );
        },
        getMode: (state) => {
            return appModesKeys[state.mode];
        },
        getConfigurationUIPositions: (state) => {
            return state.configurePositions;
        },
        getUIPosition: (state) => {
            return (name: keyof roomSetupUiPositions) => {
                return state.positions[name];
            };
        },
        getIsRuler: (state) => {
            return state.isRuler;
        },
        getIsDecoration: (state) => {
            return state.isDecoration;
        },
        getIsTooltip: (state) => {
            return state.isTooltip;
        },
    },
    actions: {
        setDeleteFlag(val) {
            this.deleteFlag = val;
        },
        setLoader(val: boolean) {
          this.loader = val;
        },
        setSelectedSceneObject(uuid: string | null, label: string | null, text: string | null, rodAvailable: boolean, hasRod: boolean) {
            // TODO
            // console.log(rodAvailable, hasRod);
            // TODO attach interface
            // @ts-ignore
            this.selectedSceneObject.uuid = uuid;
            // @ts-ignore
            this.selectedSceneObject.label = label;
            // @ts-ignore
            this.selectedSceneObject.text = text;
            // @ts-ignore
            this.selectedSceneObject.hasRod = hasRod;
        },
        unselect() {
            this.selectedSceneObject.uuid = null;
            this.selectedSceneObject.label = null;
            this.selectedSceneObject.text = null;
            this.selectedSceneObject.hasRod = false;
        },
        setElementInfoActive(mode:boolean){
            this.isElementInfoActive=mode;
        },
        setLoadProgress(value: number) {
            this.loadProgress = value;
        },
        setMode(value: number) {
            this.mode = appModes[value];
        },
        switchMode() {
            if (this.mode === 1) {
                this.mode = 2;
                const second = localStorage.getItem('second');
                if (!second){
                    this.switchIsTooltip();
                }
            } else {
                this.mode = 1;
            }
        },
        setUIPosition(positionName: keyof typeof roomSetupUiPositions, x: number, y: number) {
            this.positions[positionName] = [ x, y ];
        },
        // TODO не понял зачем надо было отделять от this.positions
        setUIPosition2(positionName: keyof typeof roomConfigurePositions, x: number, y: number) {
            this.configurePositions[positionName] = [ x, y ];
        },
        setIs3dLoaded() {
            this.is3dLoaded = true;
            this.mode = 1;
        },
        setIsRuler(value: boolean){
            return this.isRuler = value;
        },
        setIsDecoration(value: boolean) {
            return this.isDecoration = value;
        },
        switchIsRuler(){
            return this.isRuler = !this.isRuler;
        },
        switchIsDecoration() {
            return this.isDecoration = !this.isDecoration;
        },
        switchIsTooltip() {
            this.isTooltip = !this.isTooltip;
        },
    },
});
